/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function handleMiniCartConsent() {
  let miniCartConsent = document.querySelector('.cart-age__consent--mini-cart');
  const miniCartBtn = document.querySelector('.checkout-button--mini-cart');
  const miniCartForms = document.querySelectorAll('#mini-cart-form');
  let hasSubmitEventListener = false;

  if (miniCartForms.length > 0 && miniCartConsent) {
    miniCartForms.forEach((form) => {
      if (!hasSubmitEventListener) {
        form.addEventListener("submit", (e) => {
          miniCartConsent = document.querySelector('.cart-age__consent--mini-cart')
          if (miniCartConsent.querySelector('input').checked === false || (miniCartConsent.querySelector('input').checked === false && !miniCartConsent.querySelector('input').hasAttribute('checked'))) {
            e.preventDefault();
            e.stopPropagation();
            console.error("CUSTOMER HAS NOT CONFIRMED AGE");
          }
          
        });
        hasSubmitEventListener = true;
      }
    });

    miniCartConsent.addEventListener('change', (e) => {
      const miniCartLock = document.querySelector('.checkout-button__lock--mini-cart');
      if (e.target.checked) {
        miniCartBtn.removeAttribute('disabled');
        miniCartLock.style.opacity = 0;
      } else {
        miniCartBtn.setAttribute('disabled', 'disabled');
        miniCartLock.style.opacity = 1;
      }
    });
  }
}
// scrollTop =
// window.scrollY ||
// document.documentElement.scrollTop;
// scrollLeft =
// window.scrollX ||
// document.documentElement.scrollLeft,

// // if any scroll is attempted,
// // set this to the previous value
// window.onscroll = function () {
//     window.scrollTo(scrollLeft, scrollTop);
// };

window.addEventListener('DOMContentLoaded', () => {
  const predictiveSearchInput = document.querySelector('.predictive-search .predictive-search__input');
  const predictiveSearchContent = document.querySelector('.predictive-search .drawer__content');

  predictiveSearchInput.addEventListener('focus', (e) => {
    predictiveSearchContent.style["touch-action"] = "none";
  });
  predictiveSearchInput.addEventListener('blur', (e) => {
    predictiveSearchContent.style["touch-action"] = "";
  });

  document.documentElement.addEventListener('touchstart', ()=>{
    if (document.activeElement == predictiveSearchInput) {
      predictiveSearchInput.blur();
    }
  });
});

const backToTop = document.querySelector(".btt--button");

if( backToTop ) {
  backToTop.addEventListener('click', (e)=>{
    e.preventDefault();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  });
}


// Cross-mobile scroll lock helpers (iOS Safari compatible)
let bodyScrollLock = { scrollY: 0, isLocked: false };

function lockBodyScroll() {

  const isMobile = navigator.userAgentData.mobile;
  const top = isMobile ? 0 : bodyScrollLock.scrollY;
  
  if (bodyScrollLock.isLocked) return;
  bodyScrollLock.scrollY = window.scrollY || document.documentElement.scrollTop || 0;
  const body = document.body;
  body.style.position = "fixed";
  body.style.top = `-${top}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";
  body.style.overflow = "hidden";
  bodyScrollLock.isLocked = true;
}

function unlockBodyScroll() {
  if (!bodyScrollLock.isLocked) return;
  const body = document.body;
  const scrollY = bodyScrollLock.scrollY;
  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  body.style.width = "";
  body.style.overflow = "";
  bodyScrollLock.isLocked = false;
  window.scrollTo(0, scrollY);
}

const headerSearchBar = document.querySelectorAll("[data-searchbar]");
const headerSearchResultContainer = document.querySelector(".header-search__results");
const headerSearchBackground = document.querySelector(".header_search__overlay");
const headerSearchInput = document.querySelectorAll("[data-searchbar] .search-input");
const headerSearchEmpty = document.querySelector(".header-search__results--empty");
const headerSearchLoading = document.querySelector(".header-search__results--loading");
const headerSearchResults = document.querySelector("predictive-search");

if (headerSearchBar.length) {
  headerSearchBar.forEach(searchBar => {
    searchBar.addEventListener("focusin", (e) => {
      headerSearchResultContainer.classList.add("header-search__results--active");
      headerSearchBackground.classList.add("header_search__overlay--active");
      lockBodyScroll();
    });
    if (headerSearchBackground) {
      headerSearchBackground.addEventListener("click", (e) => {
        headerSearchResultContainer.classList.remove("header-search__results--active");
        headerSearchBackground.classList.remove("header_search__overlay--active");
        unlockBodyScroll();
      });
    }

    headerSearchInput.forEach(input => {
      input.addEventListener('keyup', (e) => {

        const searchTerm = e.target.value.trim();

        if (!searchTerm.length) return;

        if (headerSearchLoading) {
          headerSearchLoading.classList.add("header-search__results--loading--active");
        }

        fetch(`/search?section_id=predictive-search-results&q=${encodeURIComponent(searchTerm)}&type=product`)
        .then(res => res.text())
        .then(html => {
          if (html.length > 0) {
            headerSearchEmpty.classList.add("header-search__results--empty--hidden");
          } else {
            headerSearchEmpty.classList.remove("header-search__results--empty--hidden");
          }
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const section = doc.getElementById('shopify-section-predictive-search-results');
          if (section) {
            headerSearchResults.innerHTML = section.innerHTML;
            const noResults = section.querySelector('[data-no-results]');
            if (noResults) {
              headerSearchEmpty.classList.remove("header-search__results--empty--hidden");
            } else {
              headerSearchEmpty.classList.add("header-search__results--empty--hidden");
            }
          }
          headerSearchResults.innerHTML = section ? section.innerHTML : '';
          headerSearchLoading.classList.remove("header-search__results--loading--active");
        })
        .catch(err => {
          console.error("Predictive search error:", err);
          headerSearchLoading.classList.remove("header-search__results--loading--active");
        });
      });
    });
  });
}

// Free Gift
const freeGift = document.querySelector('[data-freegift]');
if(freeGift){
  const freeGiftThreshold = freeGift.dataset.freegiftthreshold;
  const freeGiftProduct = freeGift.dataset.freegiftproduct;
  let isProcessingFreeGift = false;
  
  document.addEventListener('cart:updated', function(event) {
    
    if(isProcessingFreeGift) return;
    
    const productExistsInCart = event.detail.cart.items.some(item => item.id == freeGiftProduct);
    
    if(event.detail.cart.items_subtotal_price >= (freeGiftThreshold)){
      if(!productExistsInCart) {
         isProcessingFreeGift = true;
         
         fetch(window.Shopify.routes.root + 'cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify({ id: freeGiftProduct, quantity: 1 })
         })
         .then(response => response.json())
         .then(data => {
           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
             bubbles: true
           }));
           isProcessingFreeGift = false;
         })
         .catch((error) => {
           isProcessingFreeGift = false;
         });
      }
    } else {
      if(productExistsInCart) {
        isProcessingFreeGift = true;
        
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: freeGiftProduct, quantity: 0 })
        })
        .then(response => response.json())
        .then(data => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          isProcessingFreeGift = false;
        })
        .catch((error) => {
          console.error('Error removing free gift:', error);
          isProcessingFreeGift = false;
        });
      }
    }
  });
}